<template>
  <sc-modal :active.sync="modal.reportProblem.showModal">
    <sc-modal-card :title="modal.reportProblem.title">
      <template slot="body">
        <create-window
          @submit="(fieldsWindow) => addWindow(fields, fieldsWindow)"
          @closeModal="modal.reportProblem.showModal = false"
        />
        <form
          @submit.prevent="onSubmitReportProblem"
          class="report-problem-form"
        >
          <sc-input
            :v-model="modal.reportProblem.model.email"
            placeholder="Digite o email para entrarmos em contato"
          />
          <sc-input
            :v-model="modal.reportProblem.model.description"
            placeholder="Descrição do problema"
          />
          <sc-button
            class="is-fullwidth"
            theme="primary"
            :text="sendEmailButton"
            :disabled="loading"
            icon="paper-plane"
            @click="() => onSubmitReportProblem()"
          />
        </form>
      </template>
    </sc-modal-card>
  </sc-modal>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
import {
  ScIcon,
  ScModal,
  ScModalCard,
  ScInput,
} from "@intelipost-js/secure-components";

const { mapState, mapActions } = createNamespacedHelpers(
  "integrations/integrationsHome"
);

export default {
  name: "page-integrations-home",

  data() {
    return {
      title: "Integrações",
      name: "",
      selectedApp: null,

      integrationListCache: [],

      integrationAppSelected: "allApps",

      modal: {
        about: {
          title: "Sobre o aplicativo",
          showModal: false,
        },
        appConfig: {
          title: "Configurando a instalação",
          showModal: false,
          dynamicForm: {
            model: {},
            schema: {
              type: "object",
              required: [],
              properties: {},
            },
            uiSchema: [],
          },
        },
        reportProblem: {
          title: "Reportando um problema",
          showModal: false,
          model: {
            email: "",
            description: "",
          },
        },
      },
    };
  },

  computed: {
    ...mapState(["loading", "integrations"]),

    installedApps() {
      return this.integrations.filter(
        (integration) => integration.installed === true
      );
    },
    appsNotInstalled() {
      return this.integrations.filter(
        (integration) => integration.installed === false
      );
    },
    allApps() {
      return this.integrations;
    },
    integrationApps() {
      return this[this.integrationAppSelected];
    },

    installButton() {
      return "Instalar";
    },

    uninstallButton() {
      return "Desinstalar";
    },

    formSaveButton() {
      return "Instalar";
    },

    sendEmailButton() {
      return "Enviar";
    },
  },

  methods: {
    ...mapActions([
      "saveIntegrationConfigs",
      "getAppList",
      "uninstallIntegrationAction",
      "updateIntegrationList",
      "installAppAction",
    ]),

    handleClose() {
      this.modal.appConfig.dynamicForm.model = {};
    },

    onSubmitInstallation() {
      const app = {
        app_id: this.selectedApp.id,
        app_config: this.modal.appConfig.dynamicForm.model,
      };

      this.installAppAction(app).then(({ ok, message }) => {
        if (ok) {
          this.getAppList();
          this.modal.appConfig.showModal = false;
          return ScToast.success("Aplicativo instalado com sucesso");
        }
        return ScToast.open({message, duration: 20000, type: 'is-danger'});
      });
    },

    loadFieldsConverted(integration) {
      if (integration !== undefined) {
        const schema = JSON.parse(integration.schemaBased);

        const schemaConverted = {
          required: [],
          properties: {},
          uiSchema: [],
        };

        schema.fields.forEach((field) => {
          schemaConverted.uiSchema.push({
            component: ScField,
            model: field.name,
            fieldOptions: {
              attrs: {
                label: field.name,
                class: ["margin-bottom: 0"],
              },
            },
          });

          if (field.type === "array" || field.type === "map") {
            schemaConverted.properties[field.name] = {
              type: "array",
              items: {
                type: "string",
              },
            };

            schemaConverted.uiSchema.push({
              component: ScTaginput,
              model: field.name,
              fieldOptions: {
                class: ["form-control"],
                on: ["input"],
                attrs: {
                  model: "fsdfs",
                  placeholder: "Aperte Enter para inputar o valor",
                },
                props: {
                  placeholder: `placeholder of ${field.name}`,
                },
              },
            });
          } else {
            schemaConverted.properties[field.name] = {
              type: field.type,
              minLength: 1,
            };

            schemaConverted.uiSchema.push({
              component: ScInput,
              model: field.name,
              fieldOptions: {
                class: ["form-control"],
                on: ["input"],
                props: {
                  placeholder: `placeholder of ${field.name}`,
                },
              },
            });
          }

          if (field.required) {
            schemaConverted.required.push(field.name);
          }
        });
        this.modal.appConfig.dynamicForm.uiSchema = schemaConverted.uiSchema;
        this.modal.appConfig.dynamicForm.schema.properties =
          schemaConverted.properties;
        this.modal.appConfig.dynamicForm.schema.required =
          schemaConverted.required;
        this.selectedApp = integration;
      }
    },

    handleFilterBySelectedAppName(option) {
      if (option === null) {
        this.getAppList();
      } else {
        const integrationFiltered = this.integrations.filter(
          (integration) => integration.name === option
        );

        this.updateIntegrationList(integrationFiltered);
      }
    },

    hasSchemaBased(integration) {
      return integration.schemaBased !== null;
    },

    callSaveIntegrationConfigs({ id }) {
      this.saveIntegrationConfigs(id).then(({ ok, message }) => {
        if (ok) {
          this.getAppList();
          return ScToast.success("Aplicativo habilitado com sucesso");
        }
        return ScToast.open({message, duration: 20000, type: 'is-danger'});
      });
    },

    handleInstallButton(integration) {
      if (this.hasSchemaBased(integration)) {
        this.loadFieldsConverted(integration);
        this.modal.appConfig.showModal = true;
      } else {
        ScDialog.confirm({
          title: "Confirmação de instalação",
          message: `Você tem certeza que deseja instalar o aplicativo <b>${integration.name}</b>?`,
          type: "is-info",
          hasIcon: true,
          icon: "check-circle",
          onConfirm: () => this.callSaveIntegrationConfigs(integration),
        });
      }
    },

    handleUninstallButton(integration) {
      return ScDialog.confirm({
        title: "Confirmação de desinstalação",
        message: `Você tem certeza que deseja desinstalar o aplicativo <b>${integration.name}</b>?`,
        type: "is-danger",
        hasIcon: true,
        icon: "times-circle",
        onConfirm: () =>
          this.uninstallIntegrationAction(integration.installation_id).then(
            ({ ok, message }) => {
              if (ok) {
                this.getAppList();
                this.integrationListCache = this.integrations;

                return ScToast.success("Aplicativo desinstalado com sucesso");
              }

              return ScToast.open({message, duration: 20000, type: 'is-danger'});
            }
          ),
      });
    },

    handleEditIntegrationButton() {
      return ScToast.danger("A função Editar ainda não está habilitada. =(");
    },

    handleMonitoringIntegrationButton() {
      return ScToast.danger("A função Monitorar ainda não está habilitada. =(");
    },

    handleAboutIntegrationButton(app) {
      this.selectedApp = app;
      this.modal.about.showModal = true;
    },

    handleReportProblemIntegrationButton() {
      this.modal.reportProblem.showModal = true;
    },
  },

  mounted() {
    this.getAppList();
    this.integrationListCache = this.integrations;
  },

  components: {
    ScIcon,
    ScModal,
    ScModalCard,
    ScInput,
  },
};
</script>

<style lang='scss'>
@import "~@intelipost-js/secure-ui/src/scss/variables";

.page-integrations {
  .filter-section {
    display: flex;
    justify-items: center;
    align-content: center;
    align-items: center;
    margin-bottom: 2rem;
  }

  .schema-form {
    display: flex;
    flex-direction: column;
    gap: 1rem;
    margin-bottom: 2rem;

    input {
      background-color: none;
    }
  }

  .group-buttons {
    margin: 0 2rem;
    padding: none;
  }

  .input-filter {
    width: 50%;
  }

  .sc-card {
    .card-header-button {
      background: none;
      border: none;
    }

    .card-image {
      .image {
        padding-top: 60%;
      }
    }

    .card-menu-button {
      border: none;
      background-color: white;
      margin: 1rem 0 0 0;
    }

    .report-problem-form {
      display: flex;
      margin-bottom: 2rem;

      .report-problem-button {
        margin-top: 2rem;
      }
    }

    img {
      object-fit: scale-down;
      width: 80%;
      margin: auto;
    }
  }

  .schema-form {
    display: flex;
    flex-direction: column;
    gap: 1rem;
    margin-right: 2rem;
  }

  .modal_about__field {
    display: flex;
    flex-direction: column;
    margin-bottom: 1rem;
  }

  &__cols {
    padding: 0.5rem;
  }

  &__col {
    width: 330px;
    padding: 0.5rem;
  }

  &__description {
    margin-bottom: 1rem;
  }

  &__notification {
    &--is-warning {
      font-size: 1.4rem;
      background-color: transparent;
      color: #767676;

      .icon {
        margin-right: 1.6rem;
        position: relative;
        top: 4px;
        font-size: 1.6rem;
      }
    }
  }

  &__icon {
    cursor: help;

    &--success {
      color: $primary;
    }

    &--danger {
      color: $danger;
    }
  }
}
</style>



// WEBPACK FOOTER //
// node_modules/@intelipost-modules/secure-integrations/components/modal/report-problem/ModalReportProblem.vue